import agencySaleHelper from 'features/DealerReconciliationReport/agencySaleHelper';
import AgencyTransactionHelper from 'features/ManageAgencyTransaction/agencyTransactionHelper';
import KTBSButton, {
    KTBSButtonColor,
    KTBSButtonSize,
} from 'general/components/OtherKeenComponents/KTBSButton';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import AppColors from 'general/constants/AppColors';
import AppConstants from 'general/constants/AppConstants';
import AppRoute from 'general/constants/AppRoute';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ShowMoreText from 'react-show-more-text';

AgencyTransactionDetailView.propTypes = {
    item: PropTypes.object,
    onClosed: PropTypes.func,
    onRejected: PropTypes.func,
    onApproved: PropTypes.func,
};

function AgencyTransactionDetailView(props) {
    // MARK: ---- params ----
    const { t } = useTranslation();
    const { item, onClosed, onRejected, onApproved } = props;

    // MARK: ---- methods ----
    const getStatusColor = (status) => {
        switch (status) {
            case 'COMPLETED':
                return 'success';
            case 'FAILED':
                return 'danger';
            default:
                return 'primary';
        }
    };
    const buildCellItem = (name, value, handleClick, valueColor) => {
        return (
            <div className="d-flex align-items-center justify-content-between gap-3 px-3 py-4">
                <span
                    style={{
                        fontWeight: '500',
                        fontSize: Utils.returnFontSize(14),
                        color: AppColors.gray[600],
                    }}
                >
                    {name}
                </span>
                {!_.isUndefined(value) ? (
                    <span
                        style={{
                            cursor: handleClick ? 'pointer' : '',
                            fontWeight: '600',
                            fontSize: Utils.returnFontSize(14),
                            color: valueColor
                                ? valueColor
                                : handleClick
                                    ? AppColors.primary
                                    : AppColors.gray[800],
                        }}
                        onClick={handleClick}
                    >
                        {value}
                    </span>
                ) : (
                    <></>
                )}
            </div>
        );
    };
    const buildSeparator = () => {
        return (
            <div
                style={{
                    borderBottom: `1px dashed ${AppColors.gray[300]}`,
                }}
            ></div>
        );
    };

    return (
        <div>
            <div className="p-4" style={{ backgroundColor: AppColors.gray[100] }}>
                <div className="row">
                    <div className="col-lg-6 pr-lg-0">
                        <div className="">
                            <span
                                style={{
                                    fontWeight: '600',
                                    fontSize: Utils.returnFontSize(14),
                                    color: AppColors.gray[900],
                                }}
                            >
                                Thông tin giao dịch
                            </span>
                            <div
                                className="mt-2"
                                style={{
                                    border: `1px solid ${AppColors.gray[300]}`,
                                    borderRadius: '5px',
                                }}
                            >
                                {buildCellItem('Loại giao dịch', 'Rút tiền')}
                                {buildSeparator()}
                                {buildCellItem('Mã giao dịch', item?.paymentCode ?? `OUT${item?.paymentId?.toString().padStart(8, '0')}`)}
                                {buildSeparator()}
                                {buildCellItem(
                                    'Người yêu cầu',
                                    item?.agency?.name ?? 'N/A',
                                    () => {
                                        if (row?.agency?.primaryRole === AppConstants.userAgencyType.sale)
                                            Utils.openInNewTab(`${AppRoute.saleList}/${row?.agencyId}`);
                                        else if (row?.agency?.primaryRole === AppConstants.userAgencyType.investor)
                                            Utils.openInNewTab(`${AppRoute.investorList}/${row?.agencyId}`);
                                        else if (row?.agency?.primaryRole === AppConstants.userAgencyType.group)
                                            Utils.openInNewTab(`${AppRoute.groupList}/${row?.agencyId}`);
                                        else Utils.openInNewTab(`${AppRoute.landlordList}/${row?.agencyId}`);
                                    }
                                )}
                                {buildSeparator()}
                                {buildCellItem(
                                    'Vai trò',
                                    t(`agencyRoleDropdownTitle_${item?.agency?.primaryRole}`) ?? ''
                                )}
                                {buildSeparator()}
                                {buildCellItem(
                                    'Thời gian',
                                    Utils.formatDateTimeToString(item?.createdAt, 'DD/MM/YYYY - HH:mm')
                                )}
                                {buildSeparator()}
                                {buildCellItem(
                                    'Trạng thái',
                                    <KTLabel
                                        text={t(`agencyPaymentStatus_${item?.status}`)}
                                        isInline={true}
                                        size={KTLabelSize.medium}
                                        additionalClassName={`label-light-${AgencyTransactionHelper.getAgencyTransactionStatusColor(item.status)}`}
                                    />
                                )}
                                {item?.status === AppConstants.agencyTransactionStatus.rejected && (
                                    <>
                                        {buildSeparator()}
                                        {buildCellItem(
                                            'Lý do từ chối',
                                            item?.reason ?? ''
                                        )}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="">
                            <span
                                style={{
                                    fontWeight: '600',
                                    fontSize: Utils.returnFontSize(14),
                                    color: AppColors.gray[900],
                                }}
                            >
                                Thông tin người nhận
                            </span>
                            <div
                                className="mt-2"
                                style={{
                                    border: `1px solid ${AppColors.gray[300]}`,
                                    borderRadius: '5px',
                                }}
                            >
                                {buildCellItem('Người thụ hưởng', item?.bankBeneficiary ?? 'N/A')}
                                {buildSeparator()}
                                {buildCellItem('Tài khoản thụ hưởng', item?.bankAccount ?? 'N/A')}
                                {buildSeparator()}
                                {buildCellItem('Ngân hàng', item?.bankName ? `${item?.bankName} (${item?.bankCode})` : '')}
                                {buildSeparator()}
                                {buildCellItem('Số tiền', item?.amount != null ? '-' + Utils.formatNumber(item?.amount) + ' VNĐ' : '', null, AppColors.danger)}
                                {buildSeparator()}
                                {buildCellItem('Số dư ví', Utils.formatNumber(item?.agency?.balance ?? 0) + ' VNĐ')}
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-12 mt-4">
                        {UIHelper.buildSectionTitle('Mô tả')}
                        {UIHelper.buildSectionCard(
                            <div
                                className="px-3 py-2"
                                style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[700])}
                            >
                                <ShowMoreText
                                    lines={3}
                                    more="Xem thêm"
                                    less="Thu gọn"
                                    className="text-break"
                                    anchorClass="text-success font-size-normal font-weight-bolder cursor-pointer hover-opacity-60"
                                    onClick={() => { }}
                                    expanded={false}
                                    truncatedEndingComponent={'... '}
                                >
                                    {item?.description}
                                </ShowMoreText>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="d-flex align-items-center gap-3 justify-content-end bg-white p-4 border-top rounded-bottom-lg">
                <KTBSButton
                    color={KTBSButtonColor.secondary}
                    title={t('Đóng lại')}
                    size={KTBSButtonSize.large}
                    borderRadius={5}
                    buttonTitleFontWeight="600"
                    onPress={onClosed}
                    buttonTitleColor={'rgba(74, 86, 119, 1)'}
                // additionalClassName="w-100"
                />
                {['REQUESTED'].includes(item?.status) && (
                    <KTBSButton
                        color={KTBSButtonColor.danger}
                        title={t('Từ chối')}
                        size={KTBSButtonSize.large}
                        borderRadius={5}
                        buttonTitleFontWeight="600"
                        onPress={onRejected}
                    // additionalClassName="w-100"
                    />
                )}
                {['REQUESTED'].includes(item?.status) && (
                    <KTBSButton
                        color={KTBSButtonColor.success}
                        title={t('Phê duyệt')}
                        size={KTBSButtonSize.large}
                        borderRadius={5}
                        buttonTitleFontWeight="600"
                        onPress={onApproved}
                    // additionalClassName="w-100"
                    />
                )}
            </div>
        </div>
    );
}

export default AgencyTransactionDetailView;
